module.exports = __webpack_public_path__ + "static/media/halo3.684e74b9.svg";